__turbopack_context__.v({
  "group": "FormGroup-module-scss-module__FoeCtq__group",
  "sub": "FormGroup-module-scss-module__FoeCtq__sub",
});
